import { MembershipRole } from '@/types/api/membership';
import { useAuthStore } from '../../stores/auth.store';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

interface ProtectedProps {
  role?: MembershipRole;
}

export default function Authorize({ role }: ProtectedProps) {
  const { context } = useAuthStore();
  const location = useLocation();

  if (!context?.groupId) {
    return <Navigate to={'/unauthorized'} state={{ from: location }} />;
  }

  if (role && !context.membershipRoles.includes(role)) {
    return <Navigate to={'/unauthorized'} state={{ from: location }} />;
  }

  return <Outlet />;
}
